<div *ngIf="!pendingStatus">
  <div class="rs-flex-row">
    <mprd-aliases-container class="rs-flex-columns small-12 medium-8"></mprd-aliases-container>
    <mprd-change-password-container
      class="rs-flex-columns small-12 medium-4"
    ></mprd-change-password-container>
  </div>
  <div class="rs-flex-row">
    <mprd-password-recovery-management
      class="rs-flex-columns small-12 medium-8"
    ></mprd-password-recovery-management>
    <mprd-mobile-app-promo *ngIf="showMobileAppPromo" 
      class="rs-flex-columns small-12 medium-4"></mprd-mobile-app-promo>
  </div>
</div>
